module.exports = __webpack_public_path__ + "media/placeholders/hotel-bdd30188.png";